import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-button-square',
  templateUrl: './button-square.component.html',
  styleUrls: ['./button-square.component.less']
})
export class ButtonSquareComponent implements OnInit {
  @Input() caption = '';
  @Input() disabled = false;
  constructor() { }

  ngOnInit(): void {
  }

}
